import { TeamMemberModel } from '@/shared/models/teams.model';
import { TeamUIModel } from '@/shared/ui-models/teams.ui-model';

function mapToUi(teamMember: TeamMemberModel[]): TeamUIModel[] {
  return teamMember.map((user) => ({
    id: user.id,
    role: user.role,
    // `team` comes back as an array — a member can sit on more than one — and TeamUIModel
    // holds string[]. Reading `.name` off the array gave undefined for both fields.
    team: user.team?.map((userTeam) => userTeam.name) ?? [],
    teamId: user.team?.map((userTeam) => userTeam.id) ?? [],
    user: { id: user.user?.id, name: user.user?.name, url: user.user?.image },
    reportsTo: {
      id: user.reportsToUser?.id ?? '',
      name: user.reportsToUser?.name ?? '',
      url: user.reportsToUser?.image ?? ''
    }
  }));
}

const salesMemebersMapper = { mapToUi };

export default salesMemebersMapper;
